(function (ws) {
    'use strict';
    ws.views.orderNotes = ws.views.form.extend({

        events: _.extend({}, ws.views.form.prototype.events, {
            'click .qut-clear-button': 'confirmClear',
            'click #terms': 'theTermsCheck',
            'mouseover .comp-tooltip-label': 'openTooltip',
            'mouseout .comp-tooltip-label': 'closeTooltip',
            'touchstart .comp-tooltip-label': 'openTooltip',
            'touchend .comp-tooltip-label': 'closeTooltip'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            this.$clearModal = $('.qut-clear-confirm');
            this.apiUrl = globals.path.api.westcon.cartLoadData;
            this.saveUrl = globals.path.api.westcon.saveCartUrl;
            this.clearQuoteUrl = globals.path.api.westcon.cartClearAll;

            ws.views.form.prototype.initialize.call(this);

            this.confirmModalId = this.$('.qut-clear-button').data('modalonconfirmation');
            this.eventAgg.on(this.confirmModalId + 'continue', this.clearQuote, this);
            this.$is3PLOrder = this.$('.is3PLOrder');

            //save cart
            this.saveCartModalId = this.$('.crt-save-cart-modal').attr('id');
            this.eventAgg.on(this.saveCartModalId + 'continue', this.saveCart, this);
            this.$cartInput = this.$('.crt-save-cart-name');
            this.$saveCartError = this.$('.crt-save-error');
            this.$saveCartSuccess = this.$('.crt-save-success');

            this.$checkTerms = this.$('#terms');
            this.$reviewSubmitBtn = this.$('#review-submit');
            this.$termsError = this.$('.terms-errors');
            this.$clearForm = this.$('.qut-clear-form');
            this.$disableSubmit = this.$('.disableSubmit');

            this.$termsError.hide();
        },

        /**
         * Launch Confirm Clear Quote Modal
         * @param {Object} e
         */
        confirmClear: function (e) {
            e.preventDefault();
            this.eventAgg.trigger(this.confirmModalId);
        },

        /**
         * Clear Quote
         */
        clearQuote: function () {
            if (this.$is3PLOrder.val() === 'true') {
                $.ajax({
                    url: globals.path.api.westcon.shoppingCartClearCart,
                    method: 'GET',
                    success: function (result) {
                        this.$clearForm.submit();
                    }.bind(this),

                    error: function (e) {
                        console.log('error', e);
                    }
                });
            } else {
                this.$clearForm.submit();
            }
        },

        /**
         * Open save cart modal
         */
        confirmSaveCart: function () {
            this.$cartInput.val('');
            this.eventAgg.trigger(this.saveCartModalId);
        },

        /**
         * Additional validation
         */
        additionalValidation: function () {
            if (this.$checkTerms.is(':checked')) {
                this.error = false;
            } else {
                this.$reviewSubmitBtn.attr('disabled', true);
                this.$termsError.show();
                this.error = true;
            }
        },

        /**
         * Checkbox Terms and Conditions
         */
        theTermsCheck: function () {
            if (this.$checkTerms.is(':checked')) {
                if (this.$disableSubmit.val() !== 'true') {
                    this.$reviewSubmitBtn.attr('disabled', false);
                }

                this.$termsError.hide();
            } else {
                this.$reviewSubmitBtn.attr('disabled', true);
                this.$termsError.show();
            }
        },

        /**
         * Extend default submit
         */
        submitForm: function() {
            ws.views.form.prototype.submitForm.call(this);
            this.$reviewSubmitBtn.addClass('spinner-before no-padding disabled').attr('disabled', true);
        },

        /**
         * open Tooltip
         */
        openTooltip: function (e) {
            var $el = $(e.target);
            $el.next().show();
            $el.parent().next().show();
        },

        /**
         * close Tooltip
         */
        closeTooltip: function () {
            this.$('.comp-tooltip-content').hide();
        }

    });
})(westcon);
